import { DocsBlockPropertyDefinition, } from "./SDKDocsBlockProperty";
/** Boolean property - Definition */
export class DocsBlockBooleanPropertyDefinition extends DocsBlockPropertyDefinition {
}
